import { Injectable } from '@angular/core';
import { Endpoints } from 'src/environments/endpoints';
import { IResUser, IMenuUser, IResMenuUser, IUserResp, IUser, IUserUpdateStatus, IResServiceActions } from '../model/http/users.model';
import { ConsumeService } from './consume.service';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { IEditEnrollUserRequest, IEnrollUserRequest } from '../model/http/enroll-user.model';
import { IAction } from '../model/http/menu.model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private readonly consumeService: ConsumeService,
    private readonly http: HttpClient
  ) { }

  getUsers(params: string): Observable<IResUser> {

    return this.consumeService.httpGet<IResUser>(
      `${Endpoints.users.base}/select?${params}`
    );
  }

  exportUsers(cvePortal: string) {
    return this.http.get(`${Endpoints.users.base}/export?site=${cvePortal}`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));
  }

  getMenuById(id: string): Observable<IMenuUser> {
    return this.consumeService.httpGet<IResMenuUser>(
      `${Endpoints.users.menu}?site=${environment.site}&email=${id}`
    ).pipe(map((res: any) => res.data));
  }

  getServiceActions(serviceId: number, rols: string): Observable<IAction[]> {
    return this.consumeService.httpGet<IResServiceActions>(
      `${Endpoints.catalogs.serviceAction}?serviceId=${serviceId}${rols}`
    ).pipe(map((res: any) => res.data));
  }

  getUsersByText(txt: string, site: string = 'PDA'): Observable<IUser[]> {

    let txtNormalize = encodeURIComponent(txt);

    return this.consumeService.httpGet<IUserResp>(
      `${Endpoints.users.base}/${txtNormalize}/ad?site=${site}`
    ).pipe(
      map((resp) => resp.data),
      catchError(() => of([]))
    );
  }

  findUsers(word: string, cvePortal: string): Observable<IUser[]> {
    return this.consumeService.httpGet<IUserResp>(`
      ${Endpoints.users.base}/${word}/user?site=${cvePortal}`
    ).pipe(map((res) => res.data));
  }

  updateStatus(dataUser: IUserUpdateStatus, id: number) {
    return this.http.patch(`${Endpoints.users.base}/changestatus/${id}`, dataUser);
  }

  getUserById(id: number): Observable<IUser> {
    return this.consumeService.httpGet<any>(
      `${Endpoints.users.base}/${id}`
    ).pipe(
      map((resp) => resp.data)
    );
  }

  enrollNewUser(request: IEnrollUserRequest) {
    return this.consumeService.httpPost(`${Endpoints.users.base}/`, request)
  }

  editUser(request: IEditEnrollUserRequest) {
    return this.consumeService.httpPut(`${Endpoints.users.base}/`, request)
  }

  loadUsersWithExcel(file: File, userName: string, site: string) {

    const formData = new FormData();

    formData.append("file", file);
    formData.append("userResponse", userName);

    return this.http.post(`${Endpoints.users.base}/import?site=${site}`, formData, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(map((res) => res.body));

  }

}
